/**
 * The normative error codes of the native-app wrapper (#2384, spec.md §12.1).
 *
 * MIRROR of `functions/nativeApp/nativeErrorCodes.js` — the WIRE VALUES of the
 * server-side list, not its code. There is no import path from `src/` into
 * `functions/` (separate packages), so the ten strings are repeated here;
 * `functions/nativeApp/nativeErrorCodes.test.js` fails if the two files differ.
 * A server rejection carries its code as `error.details.reason`.
 */

export const NATIVE_ERROR_CODES = Object.freeze({
  AUTH_REQUIRED: 'AUTH_REQUIRED',
  DEVICE_REVOKED: 'DEVICE_REVOKED',
  APP_UPDATE_REQUIRED: 'APP_UPDATE_REQUIRED',
  PUSH_PERMISSION_BLOCKED: 'PUSH_PERMISSION_BLOCKED',
  BACKGROUND_LOCATION_BLOCKED: 'BACKGROUND_LOCATION_BLOCKED',
  CHALLENGE_EXPIRED: 'CHALLENGE_EXPIRED',
  LOCAL_QUEUE_EXPIRED: 'LOCAL_QUEUE_EXPIRED',
  STATION_INVALID: 'STATION_INVALID',
  BIOMETRIC_ORIGIN_UNSUPPORTED: 'BIOMETRIC_ORIGIN_UNSUPPORTED',
  NETWORK_UNAVAILABLE: 'NETWORK_UNAVAILABLE',
})

/**
 * Whether a failed callable never reached the server (§12.1
 * NETWORK_UNAVAILABLE). Deliberately narrow: the Firebase web SDK reports a
 * failed fetch as code `functions/internal`, which a server-side 500 also
 * produces, so `internal` alone is NOT treated as "offline" — only an explicit
 * `unavailable`, a browser that says it is offline, or a raw fetch failure.
 *
 * @param {*} error What the callable rejected with.
 * @return {boolean}
 */
export function isNetworkUnavailableError(error) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return true
  const code = String(error?.code || '')
  if (code === 'unavailable' || code === 'functions/unavailable') return true
  return error instanceof TypeError && /failed to fetch|network/i.test(String(error.message))
}
